import { combineReducers } from 'redux';
import detailsReducers from './details/containers/details-reducers';
import createReducuers from './create/containers/create-order-reducer';
import changePartnerReducuers from './change-partner/containers/change-partner-reducers';
import partsReducers from './parts/containers/parts-reducers';
import subcontractsReducers from './subcontracts/containers/subcontract-reducers';
import taskListsReducer from './task-list/containers/task-list-reducers';

export default combineReducers({
  details: detailsReducers,
  create: createReducuers,
  changePartner: changePartnerReducuers,
  parts: partsReducers,
  subcontracts: subcontractsReducers,
  taskLists: taskListsReducer,
});
